<template lang="pug">
.v-related
  .v-related-ttl
    | イベント・ウェビナーを探す
    nuxt-link(to='/events') もっとみる
  .v-lst-event
    article(v-for="event in events" :key="event.id" v-if="event.entryable")
      EventsList(:event="event")
</template>

<script>
import EventsList from '~/components/events/EventsList'

export default {
  components: {
    EventsList
  },
  props: {
    events: {
      type: Array,
      required: true
    }
  }
}
</script>
